export const GASendEvent = (category: string, action: string, label: string = null, value: number = null) => {
  if (typeof window === undefined) {
    return;
  }

   // Don't track while developing
   if (process.env.NODE_ENV === 'production' && typeof gtag === 'function') {
    // Send pageview
    window.gtag('event', action, {
      'event_category': category,
      'event_label': label,
      'value': value
    })

    return;
  }
}


// WEBPACK FOOTER //
// ./src/ga.ts